import Button from 'devextreme-react/button';

const ModuleItem = ({ prop }) => {
    // console.log(prop)
    return (
    <div className={`task-item task-item-priority--low`}>
        <Button
            id={`button-${prop.id}`}
            width='100%'
            onClick={() => { window.location.href = prop.path }}>
            {prop.name}
        </Button>
    </div>
  );
}
export default ModuleItem;